<template>

  <div class="locations-list">

    <div class="single-location-wrap" v-if="stats">
      <div class="col-map">
        <a class="map-wrap-link" :href="current_location.acf_locations.direction" target="_blank">
          <div class="footer-map" v-if="stats" :style="{'background-image': 'url(' + current_location.acf_locations.location_map + ') '}"></div>
        </a>
      </div>
      <div class="col-details">
        <div class="dropdown">
          <button type="button" class="btn dropdown-toggle" data-toggle="dropdown" data-display="static">
            <span v-if="stats">{{ current_location.post_title }}</span>
            <span class="icon-dropdown">
                     <img :src="theme_path + '/assets/images/icon-accordion-plus.svg' " alt="arrow"/>
                </span>
          </button>
          <div class="dropdown-menu">
            <ul>
              <li v-for="(location, index) in locations" v-on:click="onChangeSelect(index, location.ID)">{{ location.post_title }}</li>
            </ul>
          </div>
        </div>
        <div class="inner-wrap">
          <div class="firm-name">{{ current_location.acf_locations.firm_name }}</div>
          <div class="address-wrap">
            <p class="address" v-if="current_location.acf_locations.address_1">
              {{ current_location.acf_locations.address_1 }}
            </p>
            <p class="address" v-if="current_location.acf_locations.address_2">{{ current_location.acf_locations.address_2 }}</p>
            <p>
              <span>{{ current_location.acf_locations.city }}</span>, <span>{{ current_location.acf_locations.state }}</span> <span>{{ current_location.acf_locations.zipcode }}</span>
            </p>
            <p>United States (US)</p>
            <div class="phone-wrap" v-if="current_location.acf_locations.phone">
              <p>
                <a class="phone-number ctm-no-swap" :href="'tel:' + current_location.acf_locations.phone"><span>Phone:</span> {{ current_location.acf_locations.phone }}</a>
              </p>
              <p v-if="current_location.acf_locations.phone2">
                <a class="phone-number ctm-no-swap" :href="'tel:' + current_location.acf_locations.phone2"><span>Toll Free:</span> {{ current_location.acf_locations.phone2 }}</a>
              </p>
              <p v-if="current_location.acf_locations.fax">
                <a class="phone-number ctm-no-swap" :href="'tel:' + current_location.acf_locations.fax"><span>Fax:</span> {{ current_location.acf_locations.fax }}</a>
              </p>
              <div class="appointment" v-if="current_location.acf_locations.by_appointment_only">
                <p>By Appointment Only</p>
              </div>
            </div>
          </div>
          <ul>
            <li>
              <a :href="current_location.acf_locations.direction" class="btn modal-hours-btn" target="_blank">Directions</a>
            </li>
            <li class="location-direction">
              <a data-toggle="modal" data-target="#hoursModal" :href="current_location.link" class="btn">Hours</a>
            </li>
          </ul>
          <!-- Modal -->
          <div class="modal fade" id="hoursModal" tabindex="-1" role="dialog" aria-labelledby="officeHours" aria-hidden="true">

            <div class="modal-dialog" role="document">

              <div class="modal-content">

                <div class="modal-header">

                  <h5 class="modal-title" id="exampleModalLabel">Office Hours</h5>

                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>

                </div>

                <div class="modal-body">
                  <div class="opening-hours">

                    <table>
                      <tbody>

                      <tr>
                        <td class="day">Monday</td>
                        <td class="time"><span>{{ current_location.acf_locations.monday_hours }}</span></td>
                      </tr>

                      <tr>
                        <td class="day">Tuesday</td>
                        <td class="time"><span>{{ current_location.acf_locations.tuesday_hours }}</span></td>
                      </tr>

                      <tr>
                        <td class="day">Wednesday</td>
                        <td class="time"><span>{{ current_location.acf_locations.wednesday_hours }}</span></td>
                      </tr>

                      <tr>
                        <td class="day">Thursday</td>
                        <td class="time"><span>{{ current_location.acf_locations.thursday_hours }}</span></td>
                      </tr>

                      <tr>
                        <td class="day">Friday</td>
                        <td class="time"><span>{{ current_location.acf_locations.friday_hours }}</span></td>
                      </tr>

                      <tr v-if="current_location.acf_locations.saturday_hours">
                        <td class="day">Saturday</td>
                        <td class="time"><span>{{ current_location.acf_locations.saturday_hours }}</span></td>
                      </tr>

                      <tr v-if="current_location.acf_locations.sunday_hours">
                        <td class="day">Sunday</td>
                        <td class="time"><span>{{ current_location.acf_locations.sunday_hours }}</span></td>
                      </tr>

                      </tbody>
                    </table>

                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>

    </div>

  </div>

</template>

<script>

export default {
  name: 'app',
  data: () => ({
    theme_path: WPsettings.theme_path,
    locations: null,
    current_location: null,
    stats: null
  }),
  methods: {
    getAllLocations: function () {

      var self = this;

      var data = {
        'action': 'my_locations_func',
        'whatever': "test"      // We pass php values differently!
        // 'whatever': ajax_object.we_value      // We pass php values differently!
      };

      jQuery.ajax(
          {
            dataType: 'json',
            data: data,
            url: WPsettings.ajaxurl,
          })
          .done(function (data, textStatus, jqXHR) {

            self.locations = data;

            let selected_location = data[0].acf_locations.selected_location.ID;

            let result = data.filter(page => {
              if (page.ID == selected_location) {
                return page;
              }
            });

            if (result.length < 1) {
              self.current_location = data[0];
            } else {
              self.current_location = result[0];
            }

            self.stats = true;

          })
          .fail(function () {
            console.error("REST error. Nothing returned for AJAX.");
          })
          .always(function () {

          });

    },
    onChangeSelect: function (index, id) {
      this.current_location = this.locations[index];
    }
  },
  created() {
    this.getAllLocations();
  },
  mounted: function () {
    this.$nextTick(function () {
      // Code that will run only after the
      // entire view has been rendered
    });
  },
  beforeUpdate: function () {
  },
  watch: {
    // whenever question changes, this function will run
    locations: function (newQuestion, oldQuestion) {

      var self = this;

      if (self.stats == true) {

        function preloader() {
          if (document.images) {
            var i;
            var images = new Array();
            for (i = 0; i < self.locations.length; i++) {
              images[i] = new Image();
              images[i].src = self.locations[i].acf_locations.location_map;
            }
          }
        }

        preloader();

      }

    }
  }
}
</script>

<style>
</style>
